/**
 * The one chart theme of the super-admin plane. Every recharts chart under super_admin/
 * spreads these objects instead of spelling hex values (chartTheme.static.test.js ratchets
 * it): the screens are white cards, and the earlier white-at-6%-alpha grid and ticks were
 * invisible on them.
 *
 * Contrast on white: tick slate-500 #64748b is 4.76:1 (AA for text); the former #94a3b8
 * was 2.56:1. Grid slate-200 #e2e8f0 is a hairline by design. Tooltip text #1e293b on its
 * white background is 14.6:1; legend slate-600 #475569 is 7.6:1.
 *
 * Usage: <CartesianGrid {...CHART_GRID} /> <XAxis tick={CHART_TICK} />
 *        <Tooltip {...CHART_TOOLTIP} /> <Legend {...CHART_LEGEND} />
 */
const freeze = (o) => Object.freeze(o);

export const CHART_GRID = freeze({ stroke: "#e2e8f0", strokeDasharray: "3 3" });

export const CHART_TICK = freeze({ fill: "#64748b", fontSize: 11 });

export const CHART_TOOLTIP = freeze({
  contentStyle: freeze({ background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: 8, color: "#1e293b" }),
  labelStyle: freeze({ color: "#334155" }),
});

export const CHART_LEGEND = freeze({ wrapperStyle: freeze({ fontSize: 11, color: "#475569" }) });

export const CHART_SERIES = freeze({
  revenue: "#E6B85C",
  positive: "#7FB8A4",
  negative: "#f87171",
  count: "#f59e0b",
  primary: "#3b82f6",
});
